import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { IconName, TableBulkActionButton } from '@optimus-web/core';
import { CREATE_RATE_GROUP_STARTING_POINT } from '../../../../utilities/userFlowTestIds';
import { useCreateRateGroupDialogForm } from './hooks';

interface CreateRateDialogProps {
    propertyGroupsIds?: string[];
    enterpriseIds: string[];
}

export const CreateRateGroupDialog = ({ enterpriseIds, propertyGroupsIds }: CreateRateDialogProps) => {
    const areNoRowsSelected = enterpriseIds.length === 0;
    const [renderDialog, toggleDialog] = useCreateRateGroupDialogForm({ enterpriseIds, propertyGroupsIds });

    return (
        <>
            <TableBulkActionButton
                onClick={toggleDialog}
                icon={IconName.Add}
                disabled={areNoRowsSelected}
                data-test-id={CREATE_RATE_GROUP_STARTING_POINT}
            >
                <LocalizedText textKey={TextKey.RateGroupCreate} />
            </TableBulkActionButton>
            {renderDialog()}
        </>
    );
};
